module.exports = __webpack_public_path__ + "static/media/header.81ed7476.png";